import "./CurrentPageHelp/currentpagehelp.scss";
import {
    type FC,
    type MouseEvent,
    useEffect,
    useState,
} from "react";
import { type ThunkDispatch } from "redux-thunk";
import { store } from "../../_Bootstrap/RoutingAndStore";
import { showDialog } from "../../Actions/Dialogs/DialogActions";
import { HelpPage } from "../../Common/HelpPage/HelpPage";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import { useHelpManager } from "../../Utilities/Platform/HelpManager/HelpManager";

export const CurrentPageHelp: FC = () => {
    const [ show, setShow ] = useState(false);

    const helpManager = useHelpManager();

    useEffect(() => {
        const onHelpChange = () => {
            setShow(helpManager.hasSections());
        };

        helpManager.addListener(onHelpChange);

        return () => {
            helpManager.removeListener(onHelpChange);
        };
    }, [ helpManager ]);

    if(!show) {
        return null;
    }

    const onClick = (e: MouseEvent<HTMLDivElement>): void => {
        e.stopPropagation();

        (store.dispatch as ThunkDispatch<any, any, any>)(showDialog(
            "Help",
            <HelpPage />,
            "information",
            false,
            false,
            true,
            false
        ));
    };

    return (
        <div
            id="current-page-help"
            className="header-item"
            data-testid="sh-current-page-help"
        >
            <div
                className="current-page-help-icon"
                onClick={onClick}
            >
                <FontAwesomeLight icon="question-circle" />
            </div>
        </div>
    );
};
